module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/commercial-competence/commercial-competence/cc-serasa-modal/cc-serasa-modal.component.scss
// module id = ./src/app/commercial-competence/commercial-competence/cc-serasa-modal/cc-serasa-modal.component.scss
// module chunks = main